function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as c, jsx as t, Fragment as b } from "react/jsx-runtime";
import * as h from "react";
import { useIsInverseVariant as v } from "./theme-variant-context.js";
import w from "./box.js";
import { BaseTouchable as s } from "./touchable.js";
import { Text as x, Text2 as k } from "./text.js";
import { Boxed as C } from "./boxed.js";
import I, { useIsDismissable as T } from "./maybe-dismissable.js";
import { container as P, textContainerVariant as y, imageContent as E, touchableContainer as d } from "./highlighted-card.css-mistica.js";
import { vars as H } from "./skins/skin-contract.css-mistica.js";
import { useTheme as N } from "./hooks.js";
const L = /*#__PURE__*/ h.forwardRef((e, i)=>{
    var _e_isInverse;
    const { title: r , description: a , imageUrl: o , imageFit: l  } = e, g = v(), u = (_e_isInverse = e.isInverse) !== null && _e_isInverse !== void 0 ? _e_isInverse : g, m = T(), { textPresets: f  } = N(), n = /* @__PURE__ */ c(C, {
        ref: i,
        isInverse: u,
        className: P,
        dataAttributes: _object_spread({
            "component-name": "HighlightedCard"
        }, e.dataAttributes),
        width: e.width ? `${e.width}px` : "100%",
        children: [
            /* @__PURE__ */ c("div", {
                role: m ? void 0 : "region",
                className: y[o ? "withImage" : "withoutImage"],
                "aria-label": m ? void 0 : e["aria-label"],
                children: [
                    /* @__PURE__ */ t(x, {
                        mobileSize: 18,
                        mobileLineHeight: "24px",
                        desktopSize: 20,
                        desktopLineHeight: "28px",
                        truncate: e.titleLinesMax,
                        weight: f.cardTitle.weight,
                        as: "h3",
                        hyphens: "auto",
                        children: r
                    }),
                    /* @__PURE__ */ t(w, {
                        paddingTop: 8,
                        children: /* @__PURE__ */ t(k, {
                            regular: !0,
                            color: H.colors.textSecondary,
                            truncate: e.descriptionLinesMax,
                            as: "p",
                            hyphens: "auto",
                            children: a
                        })
                    }),
                    e.button && /* @__PURE__ */ c(b, {
                        children: [
                            /* @__PURE__ */ t("div", {
                                style: {
                                    minHeight: 16,
                                    flexGrow: 1
                                }
                            }),
                            e.button
                        ]
                    })
                ]
            }),
            o && /* @__PURE__ */ t("div", {
                className: E,
                style: {
                    backgroundImage: `url(${o})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: l === "fit" ? "contain" : "cover",
                    backgroundPosition: l === "fit" ? "bottom right" : `center ${l === "fill-center" ? "center" : "right"}`
                }
            })
        ]
    });
    return e.button ? n : e.onPress ? /* @__PURE__ */ t(s, {
        onPress: e.onPress,
        trackingEvent: e.trackingEvent,
        className: d,
        children: n
    }) : e.to ? /* @__PURE__ */ t(s, {
        to: e.to,
        trackingEvent: e.trackingEvent,
        fullPageOnWebView: e.fullPageOnWebView,
        className: d,
        children: n
    }) : e.href ? /* @__PURE__ */ t(s, {
        trackingEvent: e.trackingEvent,
        href: e.href,
        newTab: e.newTab,
        className: d,
        children: n
    }) : n;
}), R = /*#__PURE__*/ h.forwardRef((_param, r)=>{
    var { "aria-label": e  } = _param, i = _object_without_properties(_param, [
        "aria-label"
    ]);
    const a = e !== null && e !== void 0 ? e : i.title;
    return /* @__PURE__ */ t(I, {
        onClose: i.onClose,
        "aria-label": a,
        width: i.width,
        children: /* @__PURE__ */ t(L, _object_spread_props(_object_spread({}, i), {
            "aria-label": a,
            ref: r
        }))
    });
}), F = R;
export { F as default };
